import { Swiper, SwiperSlide } from "swiper/react";
import {
  Autoplay,
  EffectCoverflow,
  Pagination,
  Navigation,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "../TeamSlider.css";
import { motion } from "framer-motion";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import SVGTitle from "./SVGTitle";

function Team() {
  const { t } = useTranslation();
  const [selectedMember, setSelectedMember] = useState(null);

  const teamMembers = [
    {
      id: "saad",
      image: "/assets/team images/team1.jpg",
      video: "/assets/team images/C0050.MP4",
    },
    {
      id: "aya",
      image: "/assets/team images/team2.jpg",
      video: "/assets/team images/C0050.MP4",
    },
    {
      id: "mahmoud",
      image: "/assets/team images/team3.jpg",
      video: "/assets/team images/C0050.MP4",
    },
  ];

  return (
    <motion.div
      className="slider-container d-flex flex-column pt-5"
      initial={{ opacity: 0, y: 100 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      viewport={{ once: false }}
      id="team"
    >
      <Helmet>
        <title>{t("team.pageTitle")}</title>
        <meta name="description" content={t("team.pageDescription")} />
        <meta name="keywords" content={t("team.metaKeywords")} />

        <meta property="og:title" content={t("team.pageTitle")} />
        <meta property="og:description" content={t("team.pageDescription")} />
        <meta
          property="og:image"
          content="https://saleemsmile.com/images/team-cover.jpg"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://saleemsmile.com/en/#team" />
      </Helmet>

      <div className="head text-center">
        <h2 className="mb-4 fs-1 fw-bolder">{t("team.heading")}</h2>
        <SVGTitle />
      </div>
      <Swiper
        effect="coverflow"
        loop={teamMembers.length > 3}
        grabCursor
        centeredSlides
        slidesPerView="auto"
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        coverflowEffect={{ rotate: 0, stretch: 0, depth: 100, modifier: 2.5 }}
        pagination={{ el: ".swiper-pagination", clickable: true }}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        modules={[Autoplay, EffectCoverflow, Pagination, Navigation]}
        className="swiper_container mb-5"
      >
        {teamMembers.map((member) => (
          <SwiperSlide key={member.id}>
            <img
              src={member.image}
              alt={t(`team.members.${member.id}.name`)}
              width="350"
              height="350"
              loading="lazy"
              decoding="async"
              style={{ cursor: "pointer", objectFit: "cover" }}
              data-bs-toggle="modal"
              data-bs-target="#teamModal"
              onClick={() => setSelectedMember(member)}
            />
          </SwiperSlide>
        ))}
        <div className="swiper-button-prev"></div>
        <div className="swiper-button-next"></div>
        <div className="swiper-pagination"></div>
      </Swiper>

      <div
        className="modal fade"
        id="teamModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div
            className="modal-content p-3"
            style={{
              background: "linear-gradient(to right, #2BA3DF, #6dd5ed)",
            }}
          >
            {selectedMember && (
              <div className="modal-body">
                <div className="row align-items-center">
                  <div className="col-md-4 d-none d-md-flex flex-column justify-content-center text-white text-start">
                    <h5 className="modal-title mb-3">
                      {t(`team.members.${selectedMember.id}.name`)}
                    </h5>
                    <h6 className="fw-bold mb-3">
                      {t(`team.members.${selectedMember.id}.role`)}
                    </h6>
                    <p style={{ whiteSpace: "pre-line" }}>
                      {t(`team.members.${selectedMember.id}.bio`)}
                    </p>
                  </div>

                  <div className="col-md-4 d-none d-md-flex justify-content-center">
                    {selectedMember.video && (
                      <video
                        src={selectedMember.video}
                        controls
                        autoPlay
                        muted
                        loop
                        style={{
                          width: "100%",
                          borderRadius: "12px",
                          maxHeight: "400px",
                          objectFit: "cover",
                        }}
                      />
                    )}
                  </div>

                  <div className="col-md-4 d-none d-md-flex justify-content-center">
                    <img
                      src={selectedMember.image}
                      alt={t(`team.members.${selectedMember.id}.name`)}
                      className="img-fluid rounded"
                      style={{ maxHeight: "250px", objectFit: "cover" }}
                    />
                  </div>

                  <div className="col-12 d-block d-md-none mt-3 text-center text-white">
                    {selectedMember.video && (
                      <video
                        src={selectedMember.video}
                        controls
                        autoPlay
                        muted
                        loop
                        style={{
                          width: "100%",
                          height: "300px",
                          borderRadius: "12px",
                          objectFit: "cover",
                          marginBottom: "15px",
                        }}
                      />
                    )}
                    <h5 className="modal-title mb-2">
                      {t(`team.members.${selectedMember.id}.name`)}
                    </h5>
                    <h6 className="fw-bold mb-2">
                      {t(`team.members.${selectedMember.id}.role`)}
                    </h6>
                    <p style={{ whiteSpace: "pre-line" }}>
                      {t(`team.members.${selectedMember.id}.bio`)}
                    </p>
                  </div>
                </div>
              </div>
            )}

            <div className="modal-header border-0 mx-auto">
              <button
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{
                  marginBottom: "-150px",
                  zIndex: "9999",
                  backgroundColor: "#2BA3DF",
                  border: "none",
                  borderRadius: "50%",
                  padding: "14px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i
                  className="fa-solid fa-xmark"
                  style={{ fontSize: "22px", color: "#fff" }}
                ></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Team;
